import React from "react";
import { Modal } from "react-bootstrap";
import GMSButton from "../../Common/components/GMSButton";
import GMSFillButton from "../../Common/components/GMSFillButton";
import Label from "../../Common/components/Label";


const ProductDeleteXlsModal = (props) => {
  const { showPopup, validating, status, productDeleteLog, closeDelModal, setDownloadUrl, productDelete, isManualDel } = props;

  const downloadLog = () => {
    if (productDeleteLog) {
      setDownloadUrl(productDeleteLog);
      closeDelModal()
    }
  }
  return (<>
    <Modal
      className="new-xls-modal"
      aria-labelledby="contained-modal-title-vcenter p-5"
      centered
      show={showPopup}
      onHide={closeDelModal}
      backdrop={"static"}
    >
      <Modal.Body>
        <div>
          <div>
            {
              isManualDel ? <Label
                message={"Product Delete"}
                fontWeight={"600"}
                fontSize={0.875}
              /> :
                <Label
                  message={"Upload XLS"}
                  fontWeight={"600"}
                  fontSize={0.875}
                />
            }
            <div
              className={`${status === "Completed" ? "new-upload-xls" : "validating-progress"}`}
            >
              {status === "Completed" ?
                <div className="">
                  <div className="justify-content-between align-items-center">
                    {productDelete.deletedCount > 0 ?
                      <div className="msg-upload-xls">
                        <div className="msg-upload-xls-success">
                          <span className="success-tick">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none" >
                              <path d="M11.4629 0.5L3.95174 8.5L0.537598 4.86364" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </span>
                          <Label
                            message={"Successful"}
                          />
                        </div>

                        <div className="success-msg">
                          <p>{productDelete.deletedCount} {productDelete.deletedCount === 1 ?"Product":"Products"} Successfully Deleted</p>
                        </div>
                      </div>
                      : ""}
                    {productDelete.notDeletedCount > 0 ?
                      <div className="msg-upload-xls">
                        <div className="msg-upload-xls-error">
                          <span className="error-tick">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 17 15" fill="none">
                              <path d="M7.27249 1.74505L1.19239 11.8953C1.06704 12.1124 1.00071 12.3585 1.00001 12.6092C0.999304 12.8599 1.06425 13.1064 1.18839 13.3242C1.31253 13.542 1.49154 13.7235 1.70759 13.8506C1.92365 13.9777 2.16923 14.0461 2.4199 14.0488H14.5801C14.8308 14.0461 15.0763 13.9777 15.2924 13.8506C15.5085 13.7235 15.6875 13.542 15.8116 13.3242C15.9357 13.1064 16.0007 12.8599 16 12.6092C15.9993 12.3585 15.933 12.1124 15.8076 11.8953L9.7275 1.74505C9.59953 1.53408 9.41935 1.35966 9.20434 1.2386C8.98933 1.11755 8.74675 1.05396 8.5 1.05396C8.25325 1.05396 8.01067 1.11755 7.79566 1.2386C7.58065 1.35966 7.40046 1.53408 7.27249 1.74505V1.74505Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M8.5 5.43481V8.30617" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M8.5 11.1775H8.50815" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </span>
                          <Label
                            message={"Error"}
                          />
                        </div>
                        <div className="error-msg">
                          <p>
                            <span>{productDelete.notDeletedCount + " UID"}</span> not match with the product
                          </p>
                        </div>
                      </div>
                      : ""}{
                      (productDelete.deletedCount === 0 && productDelete.notDeletedCount === 0) && <div className="msg-upload-xls">
                        <div className="msg-upload-xls-error">
                          <span className="error-tick">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 17 15" fill="none">
                              <path d="M7.27249 1.74505L1.19239 11.8953C1.06704 12.1124 1.00071 12.3585 1.00001 12.6092C0.999304 12.8599 1.06425 13.1064 1.18839 13.3242C1.31253 13.542 1.49154 13.7235 1.70759 13.8506C1.92365 13.9777 2.16923 14.0461 2.4199 14.0488H14.5801C14.8308 14.0461 15.0763 13.9777 15.2924 13.8506C15.5085 13.7235 15.6875 13.542 15.8116 13.3242C15.9357 13.1064 16.0007 12.8599 16 12.6092C15.9993 12.3585 15.933 12.1124 15.8076 11.8953L9.7275 1.74505C9.59953 1.53408 9.41935 1.35966 9.20434 1.2386C8.98933 1.11755 8.74675 1.05396 8.5 1.05396C8.25325 1.05396 8.01067 1.11755 7.79566 1.2386C7.58065 1.35966 7.40046 1.53408 7.27249 1.74505V1.74505Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M8.5 5.43481V8.30617" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M8.5 11.1775H8.50815" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </span>
                          <Label
                            message={"Error"}
                          />
                        </div>
                        <div className="error-msg">
                          <p>
                            Uploaded XLS file is empty
                          </p>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                :
                <div className="">
                  <div className="justify-content-between align-items-center">
                    <div className="mt-2 pt-4">
                      <Label
                        message={`${!validating ? "Deletion in progress" : "Validating XLS file "}`}
                        fontSize={"0.85"}
                        fontWeight={"400"}
                      />
                    </div>
                    <div className="progress custom-progress-bar">
                      <div className="progress-bar" role="progressbar" style={{ width: "25%", }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                </div>
              }
              <br />
            </div>
          </div>
          <div className="float-end d-flex mt-3">
            <GMSButton name="Cancel"
              onClick={() => closeDelModal()}
            />
            &nbsp;&nbsp;&nbsp;
            {status === "Completed" && <>
              {
                productDelete.notDeletedCount ? <GMSFillButton
                  name="Download Log"
                  onClick={() => { downloadLog() }}
                /> : <GMSFillButton
                  name="Done"
                  onClick={() => { closeDelModal() }}
                />}

            </>}
            {(status !== "Completed") && <GMSFillButton
              name="Continue"
              disabled={true}
              onClick={()=>{}}
            />}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  </>)

}
export default ProductDeleteXlsModal;
